export default __webpack_public_path__ + "static/media/img4.a83dcdb8.png";